// "Handig mee te bestellen" op de PDP: direct toevoegen zonder snelkoop-drawer
// en zonder doorsturen naar de cartpagina. De form-POST in de markup blijft de
// no-JS fallback.
if (!customElements.get("lumedi-add-to-cart")) {
  customElements.define(
    "lumedi-add-to-cart",
    class LumediAddToCart extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector("form");
        this.button = this.querySelector('button[type="submit"]');
        if (!this.form) return;

        this.onSubmit = this.onSubmit.bind(this);
        this.form.addEventListener("submit", this.onSubmit);
      }

      disconnectedCallback() {
        this.form?.removeEventListener("submit", this.onSubmit);
        clearTimeout(this.addedTimer);
      }

      onSubmit(event) {
        event.preventDefault();
        if (this.button?.getAttribute("aria-disabled") === "true") return;

        this.button?.setAttribute("aria-disabled", "true");
        this.button?.classList.add("loading");

        const formData = new FormData(this.form);
        // return_to hoort bij de no-JS fallback; met fetch blijven we op de pagina.
        formData.delete("return_to");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = formData;

        fetch(routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error(response.description || response.message);
              return;
            }

            this.showAdded();
            this.refreshCart(formData.get("id"), response);
          })
          .catch((error) => console.error(error))
          .finally(() => {
            this.button?.removeAttribute("aria-disabled");
            this.button?.classList.remove("loading");
          });
      }

      showAdded() {
        if (!this.button) return;
        this.button.classList.add("is-added");
        clearTimeout(this.addedTimer);
        this.addedTimer = setTimeout(
          () => this.button.classList.remove("is-added"),
          2000,
        );
      }

      refreshCart(variantId, response) {
        if (typeof publish === "function" && window.PUB_SUB_EVENTS?.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "lumedi-add-to-cart",
            productVariantId: variantId,
            cartData: response,
          });
        }

        // De drawer ververst zichzelf hierop zonder open te klappen en werkt
        // meteen het aantal in de header bij.
        if (document.querySelector("cart-drawer")) {
          document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
          return;
        }

        this.refreshCartBubble();
      }

      refreshCartBubble() {
        const bubble = document.getElementById("cart-icon-bubble");
        if (!bubble) return;

        fetch(`${window.Shopify.routes.root}?section_id=cart-icon-bubble`)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, "text/html");
            const source = html.querySelector(".shopify-section");
            if (source) bubble.innerHTML = source.innerHTML;
          })
          .catch((error) => console.error(error));
      }
    },
  );
}
